import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import NavigationBar from "../components/navigationbar";
import Footer from "../components/footer";
import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";
import testimonials from "../components/testimonials";
import community from "../assets/community.png";

export const TestimonialsPage = () => {
  return (
    <div className="home-page">
      {/* Navbar */}
      {isMobile ? <MobileNavigationBar /> : <NavigationBar />}

      {/* Header Section */}
      <div
        className="position-relative"
        style={{
          overflow: "hidden",
          background: "#b8cfbd",
          height: isMobile ? "25vh" : "32vh",
          maxHeight: "350px",
        }}
      >
        <Container>
          <Row className="px-0 py-3">
            <h4 className={`my-0 py-0 ${isMobile ? "text-center" : "text-center"}`}>
              Greater Austin Muslim Relief Committee
            </h4>

            <Col
              md={6}
              className={`d-flex flex-column justify-content-center px-2 ${
                isMobile ? "text-center" : "text-start"
              }`}
            >
              <h1 className="fw-bold">From the Heart of Our Community</h1>
              <h4 className="fw-normal mt-2">
                Gratitude, service, and impact — as told by our community.
              </h4>
            </Col>

            {!isMobile && (
              <Col
                md={6}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  src={community}
                  alt="Community"
                  className="img-fluid"
                  style={{ maxHeight: "190px" }}
                />
              </Col>
            )}
          </Row>
        </Container>
      </div>

      {/* Testimonials Section */}
      <Container className="my-5">
        <div
          style={{
            columnCount: isMobile ? 1 : 2,
            columnGap: "2rem",
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              style={{
                display: "inline-block",
                width: "100%",
                marginBottom: "2rem",
                padding: "1rem",
                borderTop: "3px solid #bbb",
                backgroundColor: "#f9f9f9",
              }}
            >
              <p
                className="fst-italic text-dark"
                style={{
                  textAlign: "justify",
                  fontSize: isMobile ? "14px" : "18px",
                }}
              >
                “{testimonial.fullText}”
              </p>
              <p
                className="fw-semibold mb-0"
                style={{
                  textAlign: "right",
                  fontSize: isMobile ? "14px" : "inherit",
                }}
              >
                — {testimonial.name}
              </p>
            </div>
          ))}
        </div>
      </Container>

      {/* Footer */}
      {isMobile ? <MobileFooter /> : <Footer />}
    </div>
  );
};

export default TestimonialsPage;
